<template>
  <div class="mx-auto container container--fluid">
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">

      <v-data-table :headers="headers" :items="filtered_user_types" class="elevation-1 mytable" dense :search="search">

        <template v-slot:item.srno="{ item }">
          {{ filtered_user_types.indexOf(item) + 1 }}
        </template>

        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>Clearance Department Master</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-row dense justify="center">

            <v-col cols="auto">
              <v-icon color="error">*</v-icon>
            </v-col>

            <v-col cols="4">
              <v-autocomplete id="userSelect" label="Select User Type" v-model="selected_user_type" :items=user_types
                item-text="name" outlined required dense class="mt-2" />
            </v-col>

            <v-col cols="auto">
              <v-btn class="primary button mt-2" @click="filteredList" :disabled="!selected_user_type">
                Fetch
              </v-btn>
            </v-col>
          </v-row>

          <span style="width: 20px"></span>

          <v-row dense align="center">

            <v-col cols="12" sm="3" md="3" class="d-flex align-center ml-2 mt-2 mb-2">
              <v-btn rounded color="success" outlined :loading="loader" @click="downloadFile">
                <v-icon left color="success">mdi-export</v-icon>
                Export
              </v-btn>
            </v-col>

            <v-col class="mr-8" sm="6" md="5" cols="12">
              <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details />
            </v-col>

            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="mb-2 button" small v-on="on">
                  Add Clearance Department
                </v-btn>
              </template>

              <v-card justify="center">
                <v-form v-model="valid">
                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-col cols="12" class="pb-0">
                    <v-icon color="error" small>*</v-icon>
                    <v-autocomplete label="Select User Type" v-model="editedItem.new_user_type" :items=user_types
                      item-text="name" item-value="id" outlined dense required hide-details :disabled="editedIndex!=-1" />
                  </v-col>

                  <v-col cols="12" class="pt-2">
                    <v-icon color="error" small>*</v-icon>
                    <v-autocomplete label="Select Department" v-model="editedItem.selected_dept_type" :items=dept_types
                      item-text="name" item-value="id" outlined dense required hide-details />
                  </v-col>


                  <v-col cols="12" class="pt-0">
                    <v-icon color="error" small>*</v-icon>
                    <v-text-field label="Name of Department" v-model="editedItem.display_name" outlined dense
                      hide-details />
                  </v-col>

                  <v-col cols="12" class="pt-0">
                    <v-icon color="error" small>*</v-icon>
                    <v-text-field label="Level" type="number" v-model="editedItem.level" outlined dense hide-details :disabled="editedIndex!=-1"/>
                  </v-col>


                  <v-row>
                    <v-col cols="auto" class="pt-0 pb-0 ml-9">
                      <v-checkbox dense v-model="editedItem.is_last_approving" color="success"
                        label="Is Last Approving?"></v-checkbox>
                    </v-col>
                  </v-row>

                  <v-col cols="12" sm="6" md="4" class="ml-6 pt-0" v-if='editedIndex != -1'>
                    <v-checkbox dense v-model="editedItem.isactive" color="success" label="Active"></v-checkbox>
                  </v-col>

                  <v-card-actions class="justify-center pt-0">
                    <v-btn class="button" @click="close()" :disabled="!valid">
                      Cancel
                    </v-btn>

                    <v-btn color="primary button" @click="save" :disabled="!valid" v-if="editedIndex === -1">
                      Save
                    </v-btn>

                    <v-btn color="primary button" @click="updateDepartment" :disabled="!valid" v-else>
                      Update
                    </v-btn>

                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>

        </template>

        <template justify="center" v-slot:item.is_last_approving="{ item }">
          <v-icon :color="item.is_last_approving ? 'success' : 'error'">
            {{ item.is_last_approving
              ? 'mdi-check-circle-outline'
              : 'mdi-close-circle-outline' }}
          </v-icon>
        </template>


        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>

            <v-avatar size="25" class="delete-avatar ml-2">
              <v-icon class="delete-v-icon" @click="deleteItem(item)">mdi-delete</v-icon>
            </v-avatar>
          </div>
        </template>
        <template v-slot:item.isactive="{ item }">
          <v-switch inset v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'"
            @change="toggle(item)"></v-switch>
        </template>
      </v-data-table>
    </v-card>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    valid: false,
    overlay: false,
    errorMsg: {
      name: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    selected_user_type: "",
    selected_dept_type: "",
    new_user_type: "",
    dept_name: "",
    level: "",
    dept_id: "",
    clearance_dept_list: [],
    is_last_approving: "",
    user_types: [],
    dept_types: [],
    dialog: false,
    headers: [
      {
        text: "S.No",
        align: "left",
        value: "srno"
      },
      {
        text: "User Type",
        align: "center",
        sortable: false,
        value: "usertype_name",
      },
      {
        text: "Department",
        align: "center",
        sortable: false,
        value: "department_name"
      },
      {
        text: "Department Display Name",
        align: "center",
        sortable: false,
        value: "display_name"
      },
      {
        text: "Level",
        sortable: false,
        value: "level",
        align: "center"
      },
      {
        text: "Is Last Approving",
        sortable: false,
        value: "is_last_approving",
        align: "center"
      },
      {
        text: "Status",
        align: "left",
        sortable: true,
        value: "isactive",
      },
      {
        text: "Actions",
        value: "action",
        sortable: false
      },

    ],
    hasFetched: false,
    status_array_list: [],
    status_super_master_list: [],
    filtered_user_types: [],
    editedIndex: -1,
    editedItem: {
      id: "",
      display_name: "",
      isactive: true,
      is_last_approving: false,
      level: "",
      dept_name: "",
      new_user_type: "",
      selected_dept_type: ""
    },
    defaultItem: {
      id: "",
      name: "",
      isactive: true,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Add Clearance Department" : "Edit Clearance Department";
    },
  },

  watch: {
    clearance_dept_list() {
      if (this.hasFetched && this.selected_user_type) {
        this.filteredList();
      }
    },

    dialog(val) {
      val || this.close();
    },
  },

  mounted() {
    this.onLoad();
    this.getDept();
    this.getClearanceDept();
  },
  methods: {
    downloadFile() {
      this.loader = true;

      const excelData = this.filtered_user_types.map((item, index) => ({
        "S.No": index + 1,
        "User Type": item.usertype_name,
        "Department": item.department_name,
        "Department Display Name": item.display_name,
        "Level": item.level,
        "Is Last Approving": item.is_last_approving ? "YES" : "NO",
        "Status": item.isactive ? "Active" : "Inactive"
      }));

      const worksheet = XLSX.utils.json_to_sheet(excelData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Clearance Department");
      XLSX.writeFile(workbook, "clearance_department.xlsx");

      this.loader = false;
    },

    editItem(item) {
      this.editedIndex = this.clearance_dept_list.indexOf(item);
      this.editedItem = {
        id: item.id,
        display_name: item.display_name,
        is_last_approving: item.is_last_approving,
        isactive: item.isactive,
        level: item.level,
        new_user_type: item.usertype_id,
        selected_dept_type: item.department_id
      };
      this.new_user_type = item.usertype_id;
      this.selected_dept_type = item.department_id;
      this.dept_name = item.display_name;
      this.level = item.level;
      this.dialog = true;
    },

    onLoad() {
      this.overlay = true;
      axios
        .post("/Dues/getUserTypes")
        .then((res) => {
          this.overlay = false;
          if (res.data.msg == "200") {
            this.overlay = false;
            this.user_types = res.data.user_types;
          } else {
            this.snackbar("#4caf50", "Something went wrong!")
          }

        })
        .catch((error) => {
          window.console.log(error);
        })
    },

    getDept() {
      this.overlay = true;
      axios
        .post("/Dues/getDepartments")
        .then((res) => {
          this.overlay = false;
          if (res.data.msg == "200") {
            this.overlay = false;
            this.dept_types = res.data.dept_types;
          } else {
            this.snackbar("#4caf50", "Something went wrong!")
          }

        })
        .catch((error) => {
          window.console.log(error);
        })
    },

    getClearanceDept() {
      this.overlay = true;
      axios
        .post("/Dues/getClearanceDept")
        .then((res) => {
          this.overlay = false;
          if (res.data.msg == "200") {
            this.overlay = false;
            this.clearance_dept_list = res.data.clearance_dept_list;
          } else {
            this.snackbar("#4caf50", "Something went wrong!")
          }
        })
        .catch((error => {
          window.console.log(error);
        }))

      this.new_user_type = "";
      this.selected_dept_type = "";
      this.level = "";

    },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    close() {
      this.dialog = false;
      this.status_name = "";
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedItem.new_user_type &&
        this.editedItem.selected_dept_type &&
        this.editedItem.display_name &&
        this.editedItem.level
      ) {
        const payload = {
          new_user_type: this.editedItem.new_user_type,
          selected_dept: this.editedItem.selected_dept_type,
          dept_name: this.editedItem.display_name,
          level: this.editedItem.level,
          is_last_approving: this.editedItem.is_last_approving ? this.editedItem.is_last_approving: this.is_last_approving,
        }
        axios
          .post("/Dues/saveDepartment", payload)
          .then((res) => {
            if (res.data.code == "SUCCESS") {
              this.showSnackbar("#4caf50", "Department Added Successfully...");
              this.getClearanceDept();
            } else if (res.data.code == "FAIL") {
              this.showSnackbar("#b71c1c", res.data.msg);
            } else {
              this.showSnackbar("#b71c1c", "Something went wrong...");
              sessionStorage.setItem("error-trace", res.data.error_trace);
            }
          })
          .catch((error) => {
            window.console.log(error);
          });
        this.close();
      } else {
        this.showSnackbar("#b71c1c", "Please fill all mandatory fields");
      }
    },

    isValidated() {
      if (this.editedItem.display_name) {
        return true;
      } else {
        if (!this.editedItem.display_name) {
          this.errorMsg.name = true;
          this.showSnackbar("#b71c1c", "Please fill all mandatory fields");
        }

        return false;
      }
    },

    toggle(item) {
      const data = {
        dept_id: item.id,
        toggle: item.isactive,
      };
      this.overlay = true;
      axios
        .post("/Dues/toggleDepartment", data)
        .then((res) => {
          this.overlay = false;
          if (res.data.code == "SUCCESS") {
            this.showSnackbar("#4caf50", "Department Updated!");
          } else if (res.data.code == "NA") {
            this.showSnackbar(
              "#4caf50",
              "Something went wrong, Please try again later!"
            );
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong...");
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },

    updateDepartment() {
      if (this.isValidated()) {
        this.editedItem.dept_id = this.selected_dept_type;
        axios
          .post("/Dues/editDepartment", this.editedItem)
          .then((res) => {
            if (res.data.code == "SUCCESS") {
              this.showSnackbar("#4caf50", "Department Updated Successfully...");
              this.getClearanceDept();
              this.close();
            }else if(res.data.code == "NA"){
              this.showSnackbar("#b71c1c", res.data.msg);
            } else {
              this.showSnackbar("#b71c1c", "Something went wrong!");
              sessionStorage.setItem("error-trace", res.data.error_trace);
            }
          })
          .catch((error) => {
            window.console.log(error);
          });
      }
    },

    deleteItem(item) {
      if (confirm("Are you sure you want to delete this Department?")) {
        const data = {
          id: item.id,
          user_type: item.usertype_id,
          new_user_type: item.usertype_id,
          selected_dept: item.department_id,
          level : item.level
        };
        axios
          .post("/Dues/deleteDepartment", data)
          .then((res) => {
            if (res.data.code == "SUCCESS") {
              this.showSnackbar("#4caf50", "Department Deleted Successfully...");
              this.onLoad();
              this.getClearanceDept();
            }else if(res.data.code == "NA"){
                this.showSnackbar("#b71c1c", res.data.msg);
            }else {
              this.showSnackbar("#b71c1c", "Something went wrong!");
              sessionStorage.setItem("error-trace", res.data.error_trace);
            }
          })
          .catch((error) => {
            window.console.log(error);
          });
      }
      this.close();
    },

    filteredList() {
      if (!this.selected_user_type) {
        this.filtered_user_types = []
        return
      }
      this.hasFetched = true;

      this.filtered_user_types = this.clearance_dept_list.filter(
        item => item.usertype_name === this.selected_user_type
      )
    }
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}

.v-icon-size {
  font-size: 20px;
}

.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}

.edit-avatar:hover {
  background-color: #b0bec5;
}

.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}

.edit-v-icon:hover {
  color: white;
}

.mytable /deep/ thead th {
  background: #0f2027;

  background: -webkit-linear-gradient(to right,
      #2c5364,
      #203a43,
      #0f2027);

  background: linear-gradient(to right,
      #2c5364,
      #203a43,
      #0f2027);

  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}

.v-btn.v-btn--disabled {
  border: none !important;
}
</style>